import {utils} from '@wallaby-ui/core';
import classNames, {Argument} from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import styles from './FilterSubmitButton.less';
import {ShortcutEnum} from '../../../lib/filtering';

const I18N = defineMessages({
  TITLE: {
    id: 'filter.submit.title',
    defaultMessage: 'Apply filter',
    description: 'title text for submit filter button',
  },
  LABEL: {
    id: 'filter.submit.label',
    defaultMessage: 'APPLY',
    description: 'label for submit filter button',
  },
});

interface OwnProps {
  buttonText?: string;
  className?: Argument;
  onClick: (value?: [Date | null | undefined, Date | null | undefined, ShortcutEnum | null | undefined] | undefined) => void;
  isDisabled?: boolean;
  tabIndex?: number;
  titleText?: string;
}

type Props = OwnProps;

export const FilterSubmitButton: React.FC<Props> = (props) => {
  const {
    onClick,
    buttonText = 'filter.submit.label',
    className = '',
    isDisabled = false,
    tabIndex = 0,
    titleText = 'filter.submit.title',
  } = props;
  const intl = useIntl();

  const handleClick = (event) => {
    if (event) {
      event.stopPropagation();
    }
    onClick();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      onClick();
    }
    return true;
  };

  return (
    <button
      type={'submit'}
      className={classNames(className, styles.dlFilterSubmitButton, 'float-end', {
        [styles.dlDisabledButton]: isDisabled,
      })}
      title={utils.TranslateUtils.translate({...I18N.TITLE, id: titleText}, intl)}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={isDisabled}
      tabIndex={tabIndex}
    >
      {utils.TranslateUtils.translate({...I18N.LABEL, id: buttonText}, intl)}
    </button>
  );
};

FilterSubmitButton.displayName = 'FilterSubmitButton';
